

import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from './myProfile.module.css';
import { axiosInstance } from '../../../lib/axiosInstance';
import { axiosInstanceForImage } from '../../../lib/axiosInstance';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider';
import { useAuth } from '../../global_state_components/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { getCroppedImg } from "./cropImage"; // Import helper function to extract the cropped image

import Cropper from "react-easy-crop"; // Import the Cropper component for cropping functionality
import { Button, Slider, Typography } from "@mui/material"; // Import UI components from Material-UI
import { Label } from '@mui/icons-material';


const timezones = [
  'GMT+05:30 Asia/Kolkata',
  'GMT+00:00 UTC',
  'GMT-05:00 America/New_York',
  'GMT+01:00 Europe/London',
];

const MyProfile = () => {
  const {contact, setContact, isSaved, setIsSaved} = useGlobalState();
  const {isAuthenticated, setIsAuthenticated} = useAuth();
  const navigate = useNavigate();   

  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/images/blank_profile_picture.webp' || null);

  //const [profilePhotoUrl, setProfilePhotoUrl] = useState(`${process.env.REACT_APP_BASE_URL}/api/profile/image?type=profile` || null);

  //const [profileName, setProfileName] = useState('');
  const [title, setTitle] = useState('');
  const [college, setCollege] = useState('');
  const [major, setMajor] = useState('');
  const [timezone, setTimezone] = useState(timezones[0]);
  //const [subjects, setSubjects] = useState([]);
  //const [newSubject, setNewSubject] = useState('');

  
  const [profile, setProfile] = useState({
    name: '',
    titleOrOccupation: '',
    collegeOrCompany: '',
    majorInCollegeOrSpecialisation: '',
    favouriteSubjects: []
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile({
      ...profile,
      [name]: value,
    });
  };

  const [newFile, setNewFile] = useState(null);  //I added.

  //-------------------------------------------
  // State to store the uploaded image source (as a data URL)
  const [imageSrc, setImageSrc] = useState(null);

  // State to manage the cropping position (x and y coordinates)
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  // State to manage the zoom level of the image
  const [zoom, setZoom] = useState(1);

  // State to store the pixel coordinates and dimensions of the cropped area
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // State to store the final cropped image (as a URL)
  const [croppedImage, setCroppedImage] = useState(null);

  const [uploadMessage, setUploadMessage] = useState(""); // State for upload status message





  // Function to add a new subject manually to the list. For now not including.
  /*
  const handleAddSubject = () => {
    if (newSubject && subjects.length < 10) {
      setSubjects([...subjects, newSubject]);
      setNewSubject('');
    }
  };


  const handleSubjectChange = (e) => {
    setNewSubject(e.target.value);
  };
  */



  const handleResendEmailVerificationLink = async () => {
    if (!profile.email) {
      alert("Email is not set. Please provide a valid email.");
      return;
    }

    try{
      const response = await axiosInstance.post('/auth/request-new-email-verification', {
        email: profile.email
      }); 
      alert("Verification email has been sent to "+contact.email);
      //console.log(response.data);

    }catch(error){
        console.error('Error:', error.message);
    }
  };

  //To fetch the existing profile image if any.
  useEffect(() => {
    async function getProfileDetails() {
      try {
        const response = await axiosInstance.get('/profile');
        
        setProfile(response.data); // Update the state with the image URL
      } catch (error) {
        console.error("Failed to fetch default image:", error); // Log error details
  
        if (error.response) {
          console.log("Error Data: ", error.response.data);
        }
      }
    }
  
    getProfileDetails(); // Call the async function inside useEffect
  }, []); // Empty dependency array ensures the effect runs only once



  //To fetch the existing profile image if any.
  useEffect(() => {
    async function getProfileImage() {
      try {
        const response = await axiosInstanceForImage.get('/profile/image?type=profile');
        const imageUrl = URL.createObjectURL(response.data);

        //Add canvas setting if default photo not there in server here only. I guess in the catch clause.
        setProfilePhotoUrl(imageUrl); // Update the state with the image URL
      } catch (error) {
        console.error("Failed to fetch default image:", error); // Log error details
  
        if (error.response) {
          console.log("Error Data: ", error.response.data);
          console.log("Error Status: ", error.response.status);
          console.log("Error Headers: ", error.response.headers);
        } else if (error.request) {
          console.log("Error Request: ", error.request);
        } else {
          console.log("Error Message: ", error.message);
        }
  
      }
    }
  
    getProfileImage(); // Call the async function inside useEffect
  }, []); // Empty dependency array ensures the effect runs only once
  
  
    


  // Function to handle image upload from the user's device
  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the uploaded file
    if (file) {
      //const url = URL.createObjectURL(file);
      //setProfilePhotoUrl(url);

      const reader = new FileReader(); // Use FileReader to read the file
      reader.onload = () => {
        setImageSrc(reader.result); // Set the image source as a base64-encoded string
      };
      reader.readAsDataURL(file); // Read the file as a data URL

      setIsSaved(false);          // Set 'isSaved' to false, indicating that changes have been made to the profile photo 
      // but not yet saved (e.g., to the server or in user preferences).

    }
  };





  // Callback triggered when cropping is completed, updates the cropped area state
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels); // Store pixel data for further processing
  }, []);



  // Function to handle the cropping process and generate the final cropped image
  const handleCrop = useCallback(async () => {
    try {
      // Use the helper function to crop the image using the source and cropped area
      const croppedImg = await getCroppedImg(imageSrc, croppedAreaPixels);
      //const croppedImgUrl = URL.createObjectURL(croppedImg);
      setCroppedImage(croppedImg); // Store the resulting cropped image URL
    } catch (error) {
      console.error("Crop failed:", error); // Log errors in case cropping fails
    }
  }, [imageSrc, croppedAreaPixels]);




  const handleSave = async () => {
  
    try {
      // --- Upload the profile image if a new image is selected.---
      if (croppedImage) {
        //console.log("typeof(croppedImage) : " + typeof(croppedImage));  // string
        //console.log("croppedImage : " + croppedImage);   //blob:
      
        // Fetch the Blob object from the Blob URL
        const response = await fetch(croppedImage);
        const blob = await response.blob();    //object
      
        const formData = new FormData();
        formData.append('image', blob); // Append the Blob object     //blob:
        //console.log("typeof(formData) : " + typeof(formData));

        // Upload the profile image
        const imageResponse = await axiosInstanceForImage.post('/profile/upload', formData);
        setUploadMessage("Image uploaded successfully!"); // Show success message
        //console.log("Upload response:", imageResponse.data);
      }

      // --- Update profile details ---
      // Create a copy of the profile object without unwanted fields
      const { _id, email, roles, userType, emailVerified, __v, ...profileData } = profile;

      // Log the profile object before sending it
      //console.log("Profile object:", JSON.stringify(profileData, null, 2));
  
      // Update profile details
      const profileResponse = await axiosInstance.patch('/profile', profileData);
      //console.log("Profile update response:", profileResponse.data);
  
      setIsAuthenticated('authenticated');
      setIsSaved(true);
      (isAuthenticated === 'authenticated') && (navigate('/matrix'));
  
    } catch (error) {
      console.error("Upload failed:", error); // Log error details
      setUploadMessage("Image upload failed. Please try again."); // Show error message
  
      if (error.response) {
        console.log("Error Data: ", error.response.data);
      }
    }
  };
  




  return (
    <div className={styles.profile_page}>
      <h1>Profile</h1>



      <div className={styles.container}> {/* Main container for the cropper UI */}
        {/*<h5>Upload and Crop Your Profile Photo</h5>/} {/* Header */}

        {(imageSrc) ? ( // If an image is uploaded, show the cropper UI 
                      (croppedImage)?( // If no image is uploaded, show the file input field
                        <div>
                          <div className={styles.cropped_image_preview}> {/* Container for the preview */}
                            {/* <Typography variant="h6">Cropped Image Preview:</Typography>*/}
                            <img
                              src={croppedImage ? croppedImage : profilePhotoUrl} // Display the cropped image
                              alt="Cropped" // Alternate text for the image
                            />
                          </div>
                          <label className={styles.upload_change_label} htmlFor="fileInput">
                            Upload/Change
                            <input
                              id='fileInput'
                              type="file" // Accept files from the user's system
                              accept="image/*" // Only allow image files
                              onChange={handleImageUpload} // Trigger the image upload handler on change
                              style={{ display: 'none' }}
                            />

                          </label>
                        </div>
                      ):(
                        <div>
                          <div className={styles.crop_container}> {/* Container for the cropping tool */}
                            <Cropper
                              image={imageSrc} // Image source to be cropped
                              crop={crop} // Current crop position
                              zoom={zoom} // Current zoom level
                              aspect={1} // Aspect ratio (1:1 for profile pictures)
                              onCropChange={setCrop} // Update crop position when changed
                              onZoomChange={setZoom} // Update zoom level when changed
                              onCropComplete={onCropComplete} // Trigger callback when cropping is completed
                            />
                          </div>
                          <div className={styles.controls}> {/* Controls for zoom and crop actions */}
                            {/* <Typography>Zoom</Typography>*/}   {/*Label for zoom slider */}
                            <Slider
                              value={zoom} // Current zoom level
                              min={1} // Minimum zoom
                              max={3} // Maximum zoom
                              step={0.1} // Step size for zoom adjustments
                              onChange={(e, zoomValue) => setZoom(zoomValue)} // Update zoom state on slider change
                            />
                            <Button
                              variant="contained" // Styled button
                              color="primary" // Primary color
                              onClick={handleCrop} // Trigger the crop handler on click
                            >
                              Crop Image
                            </Button>

                            
                            
                            {/* <div className={styles.photo_placeholder}>Upload Photo</div> */}
                            {/* <Button variant="contained" color="primary" style={{ height: "50px", width: "60px" }}>
                              Upload Photo
                            </Button> */}
                            {/* <label style={{ height: "50px", width: "120px" , background: "blue"}} >
                              Upload/Change
                              <input
                                type="file" // Accept files from the user's system
                                accept="image/*" // Only allow image files
                                onChange={handleImageUpload} // Trigger the image upload handler on change
                                // style={{ margin: "20px 0" }} // Add some margin
                                style={{ display: 'none' }}
                              />

                            </label> */}

                          </div>
                        </div>
                        
                      )




        ) : ( // If no image is uploaded, show the file input field



          <div>
            <div className={styles.cropped_image_preview}> {/* Container for the preview */}
              {/* <Typography variant="h6">Cropped Image Preview:</Typography>*/}
              <img
                src={croppedImage ? croppedImage : profilePhotoUrl} // Display the cropped image
                alt="Cropped" // Alternate text for the image
              />
            </div>
            <label className={styles.upload_change_label}  htmlFor="fileInput">
              Upload/Change
              <input // Accept files from the user's system
                id='fileInput'
                type="file" // Accept files from the user's system
                accept="image/*" // Only allow image files
                onChange={handleImageUpload} // Trigger the image upload handler on change
                style={{ display: 'none' }}
              />
            </label>
          </div>
        )}
      </div>



      {/* Editable Fields */}
      <div className={styles.input_group}>
        <label>
          Name:
          <input
            type="text"
            name='name'
            value={profile.name}
            onChange={handleInputChange}
            placeholder="Enter your name"
          />
        </label>
      </div>
      <div className={styles.input_group}>
        <label>
          Title/Occupation:
          <input
            type="text"
            name='titleOrOccupation'
            value={profile.titleOrOccupation}
            onChange={handleInputChange}
            placeholder="Enter your title"
          />
        </label>
      </div>
      <div className={styles.input_group}>
        <label>
          College/Company:
          <input
            type="text"
            name='collegeOrCompany'
            value={profile.collegeOrCompany}
            onChange={handleInputChange}
            placeholder="Enter your college or company name."
          />
        </label>
      </div>
      <div className={styles.input_group}>
        <label>
          Major in College:
          <input
            type="text" 
            name='majorInCollegeOrSpecialisation'
            value={profile.majorInCollegeOrSpecialisation}
            onChange={handleInputChange}
            placeholder="Enter your major"
          />
        </label>
      </div>

      {/* Timezone Dropdown */}
      {/* <div className={styles.input_group}>
        <label>
          Your Timezone:
          <select value={profile.timezone} onChange={(e) => setTimezone(e.target.value)}>
            {timezones.map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
        </label>
      </div> */}

      {/* Favorite Subjects */}
      {/* 
      <div className={styles.subjects_section}>
        <h3>Favourite Subjects</h3>
        {profile.favouriteSubjects.map((subject, index) => (
          <div key={index}>{subject}</div>
        ))}
        {subjects.length < 10 && (
          <div className={styles.add_subject}>
            <input
              type="text"
              name='newSubject'
              value={newSubject}
              onChange={handleSubjectChange}
              placeholder="Add a new subject"
            />
            <button onClick={handleAddSubject}>Add</button>
          </div>
        )}
      </div> 
      */}

      {
        (isAuthenticated === 'email-unverified')&&(
          <h3 className={styles.email_unverfied_text}>Email not verified.</h3>
        )
      }

      {/* resend_verification_email_and_save_button_container */}
      <div className={styles.resend_verification_email_and_save_button_container}>
        <button className={styles.resend_email_verification_button} onClick={handleResendEmailVerificationLink}>
          Resend verification email
        </button>

        <button className={styles.save_button} onClick={handleSave}>
          Save
        </button>
      </div>

    </div>
  );
};

export default MyProfile;








